// Geographic helpers shared by the directory map (clients, providers, law
// firms) and the admin map.

// Distance in metres between two coordinates.
export function metersBetween(aLat, aLng, bLat, bLng) {
  const R = 6371000;
  const toRad = d => (d * Math.PI) / 180;
  const dLat = toRad(bLat - aLat);
  const dLng = toRad(bLng - aLng);
  const s = Math.sin(dLat / 2) ** 2
    + Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
}

// Facilities that share an address — or sit a few doors apart — stack
// invisibly on a map: one marker draws exactly over another and only the
// last one is visible or clickable. Group them so a single marker can
// represent (and list) everything at that spot.
//
// We group rather than fan markers out artificially: a pin must never sit
// where the thing isn't. Same principle as never falling back to a state
// centroid when an address won't geocode.
export const COLOCATED_METERS = 150;

export function groupByProximity(items, getLatLng, maxMeters = COLOCATED_METERS) {
  const groups = [];
  for (const item of items) {
    const [lat, lng] = getLatLng(item) || [];
    if (lat == null || lng == null) continue;
    const hit = groups.find(g => metersBetween(g.lat, g.lng, lat, lng) <= maxMeters);
    if (hit) hit.items.push(item);
    else groups.push({ lat, lng, items: [item] });
  }
  return groups;
}
